/**
 * TODO: Move all Channel functionality here from legacy code
 * (move filterChannelsByGuestGroups, sortChannelsByLanguage, $.get(channellist_path + '?_=' + Math.random(),)
 */

import {inject, Injectable} from './di';
import {GuestService} from './guest-service';
import {Logger} from './logger';
import {I18nService} from './i18n/i18n-service';
import {AppInitializeService} from './app-initialize-service';
import {ConfigService} from './config/config-service';
import {StructService} from './struct/struct-service';
import {getJson} from './utils/get-json';
import {distinctUntilChanged} from 'rxjs/operators';
import deepEqual from 'fast-deep-equal';
import {LegacyLogService} from './logger/legacy-log-service';

/**
 * Service for managing TV channels, including filtering and sorting.
 * Automatically updates channels when guest groups change.
 */
@Injectable()
export class ChannelService implements AppInitializeService {
  private readonly logger = inject(Logger);
  private readonly guestService = inject(GuestService);
  private readonly i18nService = inject(I18nService);
  private readonly configService = inject(ConfigService);
  private readonly structService = inject(StructService);
  private readonly legacyLogService = inject(LegacyLogService);

  constructor() {
    window.fixChannels = () => {
      // TODO: refactor this hotfix!
      // Move to init() after refactoring
      this.guestService.guestGroups$.pipe(distinctUntilChanged(deepEqual)).subscribe(() => {
        this.updateChannels();
      });
    };
  }

  public async init(): Promise<boolean> {
    // TODO cleanup and refactor:
    //  subscribe to locale chain, guestGroups,
    //  move all channel filtration and sorting logic here
    //  move channel filtering based on guest groups logic here
    try {
      let channelListPath = this.structService.contentUrl + 'channellist.json';
      const configChannelListPath = this.configService.config.desktop?.channellist;
      if (window.tv_desktop_mark && configChannelListPath) {
        channelListPath = configChannelListPath;
      }
      channelListPath = channelListPath + '?_=' + Math.random();

      const channelListData: ChannelList = await getJson(channelListPath);
      let channels: ChannelConfig[] | undefined;

      if (channelListData) {
        const localeChain = this.i18nService.localeFallbackChain$.getValue(); // TODO refactor to subscription to locale and fallbacks

        for (let i = 0; i < localeChain.length; i++) {
          const locale = localeChain[i];
          if (channelListData[locale] && channelListData[locale].length) {
            channels = channelListData[locale];
            break;
          }
        }
      }
      if (!channels || !channels.length) {
        this.logger.critical(`[ChannelService] Unable to find TV channel list information for available locales`);
        window.tv_channels = [];
        // It is a critical error, but we still can operate other parts of the application
        return true;
      }

      window.tv_channels = channels;
      this.legacyLogService.add('CHANNELS: channels loaded = ' + channels.length);
      this.logger.debug(`[ChannelService] Loaded ${channels.length} channels`);

      return true;
    } catch (err) {
      this.logger.error('[ChannelService] Failed to initialize TV channel list information', err);
      window.tv_log('Channellist error');
      return false;
    }
  }

  private updateChannels(): void {
    // TODO: a lot of legacy code here, needs refactoring
    try {
      if (window.tv_channels && window.filterChannelsByGuestGroups && window.sortChannelsByLanguage) {
        window._tv_channels = window.filterChannelsByGuestGroups(window.tv_channels);
        window._tv_channels = window.sortChannelsByLanguage(window._tv_channels);

        if (window.tv_channellist_build) {
          window.tv_channellist_build();
        }

        if (window.HotezaTV && window.event_channels_ready) {
          $(window.HotezaTV).trigger(window.event_channels_ready, {channels: window._tv_channels});
        }

        // Workaround for core modules that depend on _tv_channels (currently Epg.js).
        // Services (including ChannelService) initialize AFTER core modules, so EPG doesn’t know
        // when the channel list is ready. We trigger 'channels_updated' to fix it for modules,
        // which are not services yet.
        $(HotezaTV).trigger('channels_updated');
        this.logger.debug('[ChannelService] Channels updated');
      } else {
        this.logger.warn('[ChannelService] Required functions not available for channel update');
      }
    } catch (err) {
      this.logger.error('[ChannelService] Failed to update channels', err);
    }
  }
}

declare global {
  interface Window {
    tv_channels: unknown[];
    _tv_channels: unknown[];
    filterChannelsByGuestGroups: (channels: unknown[]) => unknown[];
    sortChannelsByLanguage: (channels: unknown[]) => unknown[];
    tv_channellist_build: () => void;
    event_channels_ready: string;
  }
}

export interface ChannelList {
  [locale: string]: ChannelConfig[];
}

export interface ChannelConfig {
  id: string;
  name: string;
  type: 'hls' | 'ip' | 'rf';
  protocol: string;
  broadcastType: string;
  port: string;
  language: string[];
  image: string;
  category: string;
  groups: any[];
  devices: any[];
  contentTypes: string[];
  background: string;
  order: string;
  epg: string;
}
